import React, {useState } from 'react';
import Dialog from '@mui/material/Dialog';
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import {get} from "../../common/network";
import {toast} from "react-toastify";
import CircularProgress from "@mui/material/CircularProgress";

const FilingDocumentModal = ({filingDocumentModalOpen, setFilingDocumentModalOpen,clickedFileData}) => {

    const [isLoading,setIsLoading] = useState(false);
    const [loadingStates, setLoadingStates] = useState({});

    const handleDownload = async (e, docId) => {
        setLoadingStates(prevState => ({ ...prevState, [docId]: true }));
        await downloadFiles(e, docId);
        setLoadingStates(prevState => ({ ...prevState, [docId]: false }));
    };

    const downloadFiles = async (e,fileId) => {
        try {
      
          let filedDocumentIds = [];
          if (fileId){
            filedDocumentIds.push(fileId);
          } else {
            setIsLoading(true);
            for (const row of clickedFileData?.filedDocuments) {
                filedDocumentIds.push(row.id);
              }
          }
         
          const response = await get(
            `docgen/filed-documents/download`,
            {
              params: {
                filedDocumentIds: JSON.stringify(filedDocumentIds),
              },
              responseType: "blob", 
            },
            false
          );
          const timestamp = new Date().getTime();
    
            const contentDispositionHeader =
              response?.headers["content-disposition"];
            const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            const matches = filenameRegex.exec(contentDispositionHeader);
            let suggestedFilename;
            if (filedDocumentIds.length!==1) {
                suggestedFilename = `Filed Documents-${timestamp}.zip`;
            } else {
                suggestedFilename = matches && matches[1] && matches[1].replace(/['"]/g, "");
            }
            
            // Create a Blob from the response content
            const mimeType = response?.headers["content-type"];
            const blob = new Blob([response.data], {type: mimeType});
    
            // Create a URL for the blob response
            const url = URL.createObjectURL(blob);
    
            // Create a hidden anchor element
            const anchor = document.createElement("a");
            anchor.style.display = "none";
            anchor.href = url;
            anchor.download = suggestedFilename; // Set the desired file name
    
            // Append the anchor to the document body
            document.body.appendChild(anchor);
    
            // Simulate a click on the anchor to trigger the download
            anchor.click();
    
            // Remove the anchor from the document body
            document.body.removeChild(anchor);
          
        } catch (error) {
        } finally {
          setIsLoading(false);
        }
      };
    

  return (
    <Dialog
      open={filingDocumentModalOpen}
      onClose={() => setFilingDocumentModalOpen(false)}
      aria-labelledby="confirmation-dialog-title"
      aria-describedby="confirmation-dialog-description"
      fullWidth
      maxWidth="md"
    >
    <Box sx={{m:4}}>
        <Typography  variant="h3">Documents</Typography>
        <Grid container justifyContent="space-between" alignItems="center">
            <Grid item>
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography variant="caption" sx={{ color: "grey" }}>Workbench ID:</Typography>
                    <Typography variant="h6">{clickedFileData?.workbenchId}</Typography>
                </Box>
            </Grid>

            <Grid item>
                <Typography variant="caption" sx={{color: "grey"}}> Docket No:</Typography>
                <Typography variant="h6">{clickedFileData?.matterData?.host_file_number}</Typography>
            </Grid>
            <Grid item>
               <Box sx={{ display: 'flex', flexDirection: 'column', alignItems:"center", justifyContent:"center", cursor:"pointer"}} onClick={(e)=>downloadFiles(e,null)}>
                    {isLoading ? <CircularProgress fontSize="small"/> : <>
                        <FileDownloadOutlinedIcon fontSize="small" sx={{color: "grey",}}/>
                        <Typography variant="h6" sx={{color: "grey"}}>Download All</Typography>
                    </>
                   }
                </Box>
            </Grid>
        </Grid>
    </Box>

    <Box sx={{ml:4,mr:4,mb:2}}>
        {clickedFileData?.filedDocuments?.map((doc,i)=> 
            <Grid container justifyContent="space-between" alignItems="center" sx={{mb:2}}>
                <Grid item sx={{color: "grey"}}>
                    {`${i+1}. ${doc?.name || ""}`}
                </Grid>
            <Grid item sx={{cursor:"pointer"}} onClick={(e)=> handleDownload(e,doc.id)}>
                    {loadingStates[doc.id] ? <CircularProgress fontSize="small"/> :<FileDownloadOutlinedIcon fontSize="small" />}
                </Grid>
            </Grid>
            )}
    </Box>
    </Dialog>
  );
}

export default FilingDocumentModal;
